/*global angular */

(function (angular) {
'use strict';

var adminHelper = angular.module('adminHelper', [
    'ngRoute',
    'cauth',
    'adminHelper.controllers',
    'adminHelper.services',
    'adminHelper.directives',
]);

adminHelper.config([
    '$interpolateProvider', '$locationProvider', '$httpProvider',
    'startSymbol', 'endSymbol', 'hashCorrector', '$logProvider', 'DEBUG',
    function($interpolateProvider, $locationProvider, $httpProvider,
             startSymbol, endSymbol, hashCorrector, $logProvider, DEBUG) {
        $interpolateProvider.startSymbol(startSymbol);
        $interpolateProvider.endSymbol(endSymbol);

        $locationProvider.html5Mode(false).hashPrefix('!');
        hashCorrector();

        $logProvider.debugEnabled(DEBUG);

        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

    }
]);


var $injector = angular.injector(['ng', 'readly.services']),
    template = $injector.get('template');

adminHelper.config(['$routeProvider', function($routeProvider) {
    $routeProvider
        .when('/:objects_type/:page?', {
            templateUrl: template.url('admin-helper', 'objects.html'),
            controller: 'ObjectListCtrl',
        })
        .otherwise({
            redirectTo: '/books/1'
        })
    }
]);

}(angular));
